import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useAuth } from '@/context'
import { LandingPage } from '@/pages/landing'

function RootIndex() {
  const { user, loading } = useAuth()

  if (!loading && user) {
    return <Navigate to="/dashboard" replace />
  }

  return <LandingPage />
}

export const Route = createFileRoute('/')({
  component: RootIndex,
})
